// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"101":"f4b01eee","109":"221422f3","154":"bbaba4a7","254":"4ee59aab","343":"5b91aef0","395":"60d4ca6a","642":"60cf6a88","858":"d449b7cc","904":"b54c2362","973":"7135c9c8"}[chunkId] + ".chunk.js";
};